import script from "./Picks.vue?vue&type=script&setup=true&lang=js"
export * from "./Picks.vue?vue&type=script&setup=true&lang=js"

import "./Picks.vue?vue&type=style&index=0&id=19daebba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19daebba"]])

export default __exports__